// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LibraryPanelDetailsTab-module__detailsTabContainer--vxF35{max-width:400px;margin:30px;display:flex;flex-direction:column;gap:40px;color:var(--gray-6)}.LibraryPanelDetailsTab-module__detailsTabContainer--vxF35 .LibraryPanelDetailsTab-module__revisionDetailsContainer--b9Ayg p{margin-bottom:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailsTabContainer": `LibraryPanelDetailsTab-module__detailsTabContainer--vxF35`,
	"revisionDetailsContainer": `LibraryPanelDetailsTab-module__revisionDetailsContainer--b9Ayg`
};
module.exports = ___CSS_LOADER_EXPORT___;
